import { styled } from '@mui/system';
import { Modal as MuiModal } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

interface ImageModalProps {
  isProduct: boolean;
}

const Modal = styled(MuiModal)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
const ImageModalContainer = styled('div')({
  position: 'relative',
});
const ImageModal = styled('img', {
  shouldForwardProp: (prop) => prop !== 'isProduct',
})<ImageModalProps>(({ isProduct }) => ({
  ...(isProduct
    ? {
        maxWidth: '90dvw',
        maxHeight: '90dvh',
      }
    : {
        maxWidth: '75dvw',
        maxHeight: '90dvh',
      }),
}));

const PdfImage = styled('object')({
  width: '75vw',
  height: '90dvh',
  objectFit: 'cover',
});

const DeleteIconButton = styled(IconButton)({
  backgroundColor: 'rgb(50, 49, 54)',
  color: 'white',
  height: '35px',
  width: '35px',
  position: 'absolute',
  top: '8px',
  right: '8px',
});

const CloseIconSized = styled(CloseIcon)({
  fontSize: '25px',
});

const DownloadIconButton = styled(IconButton)({
  backgroundColor: 'rgb(50, 49, 54)',
  color: 'white',
  height: '35px',
  width: '35px',
  position: 'absolute',
  bottom: '8px',
  right: '8px',
  cursor: 'pointer',
  borderRadius: '50%',
});

const DownloadIconSized = styled(DownloadIcon)({
  fontSize: '25px',
});

interface ModalImageProps {
  imageModal: boolean;
  setImageModal: (value: boolean) => void;
  imageUrl: string;
  handleImageError: () => void;
  productName: string;
  isProduct: boolean;
}

export function ModalImage(props: ModalImageProps) {
  const {
    imageModal,
    setImageModal,
    imageUrl,
    handleImageError,
    productName,
    isProduct,
  } = props;

  return (
    <>
      <Modal open={imageModal} onClose={() => setImageModal(false)}>
        <ImageModalContainer>
          {!imageUrl?.includes('.pdf') && (
            <>
              <ImageModal
                src={imageUrl}
                alt={`Foto ${productName}`}
                onError={handleImageError}
                isProduct={isProduct}
              />
              <DeleteIconButton onClick={() => setImageModal(false)}>
                <CloseIconSized />
              </DeleteIconButton>
              {!isProduct && (
                <DownloadIconButton
                  onClick={() => window.open(imageUrl, '_blank')}
                >
                  <DownloadIconSized />
                </DownloadIconButton>
              )}
            </>
          )}
          {imageUrl?.includes('.pdf') && (
            <>
              <PdfImage
                data={imageUrl}
                type="application/pdf"
                title="Contenedor"
              ></PdfImage>
            </>
          )}
        </ImageModalContainer>
      </Modal>
    </>
  );
}
